import React from "react"
import UpcomingAppointmentCarousel from "../UpcomingAppointmentCarousel/UpcomingAppointmentCarousel"
import "./BookAppointmentDrawer.scss"

export default function BookAppointmentDrawer({ upcomingAppointments }: any) {
  return (
    <div className="book-appointment-drawer">
      <UpcomingAppointmentCarousel
        upcomingAppointments={upcomingAppointments}
        displayActionButtons={false}
      />
    </div>
  )
}
